import React from "react";
import ReactDOM from "react-dom/client";
// The shared base first: it declares the layer order (reset, kt, kui). Then the
// site's styles, the family themes, the scale tokens and the shared UI.
import "@jkast90/kast-common/base.css";
import "./app.css";
import "@jkast90/kast-common/theme.css";
import "@jkast90/kast-common/tokens.css";
import "@jkast90/kast-common/ui.css";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
